import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	breadCrumb: null,
	activeTree: null,
	businessArea: null,
	folder1: null,
	folder2: null,
	folder3: null,
	property: null,
	news: null,
	favoriteList: null,
};

const appSlice = createSlice({
	name: 'app',
	initialState,
	reducers: {
		setBreadCrumb: (state, action) => {
			if (action.payload?.breadCrumb) {
				state.breadCrumb = action.payload.breadCrumb;
			}
		},
		setActiveTree: (state, action) => {
			if (action.payload?.activeTree) {
				console.log('setting activeTree', action.payload?.activeTree);
				state.activeTree = action.payload.activeTree;
			}
		},
		setBusinessArea: (state, action) => {
			if ('businessArea' in action.payload) {
				state.businessArea = action.payload.businessArea;
			}
		},
		setFolder1: (state, action) => {
			if ('folder1' in action.payload) {
				state.folder1 = action.payload.folder1;
			}
		},
		setFolder2: (state, action) => {
			if ('folder2' in action.payload) {
				state.folder2 = action.payload.folder2;
			}
		},
		setFolder3: (state, action) => {
			if ('folder3' in action.payload) {
				state.folder3 = action.payload.folder3;
			}
		},
		setProperty: (state, action) => {
			if ('property' in action.payload) {
				state.property = action.payload.property;
			}
		},
		setNews: (state, action) => {
			if ('news' in action.payload) {
				state.news = action.payload.news;
			}
		},
		setFavoriteList: (state, action) => {
			if ('favoriteList' in action.payload) {
				state.favoriteList = action.payload.favoriteList;
			}
		},
	},
});

export default appSlice.reducer;
export const {
	setBreadCrumb, setActiveTree, setBusinessArea, setFolder1, setFolder2, setFolder3, setProperty, setNews, setFavoriteList,
} = appSlice.actions;

export const selectBreadCrumb = (state) => state.app.breadCrumb;
export const selectActiveTree = (state) => state.app.activeTree;
export const selectBusinessArea = (state) => state.app.businessArea;
export const selectFolder1 = (state) => state.app.folder1;
export const selectFolder2 = (state) => state.app.folder2;
export const selectFolder3 = (state) => state.app.folder3;
export const selectProperty = (state) => state.app.property;
export const selectNews = (state) => state.app.news;
export const selectFavoriteList = (state) => state.app.favoriteList;
